import React, { Component } from 'react'
import { connect } from 'react-redux'

import { filterGroupMembers } from './actions'

export const mapStateToProps = (state) => ({
    groupStackState: state.getIn(['ui', 'groupStack']),
})

export default (InnerComponent) => {
    @connect(mapStateToProps, { filterGroupMembers })
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
